import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { apiGet } from '@/api/api.ts'

export type TimelineKind = 'status' | 'emergency' | 'fall' | 'bio' | 'emergencyTest'

export type TimelineUnavailableReason =
  | 'lbs_not_found'
  | 'lbs_error'
  | 'no_location_data'
  | 'invalid_coordinates'

export interface ITimelineLocation {
  latitude: number
  longitude: number
  accuracy: number
}

// 하루 위치 이력 한 줄. 위치를 확인하지 못한 시점은 location 이 null 이다.
export interface IUserTimelineItem {
  order: number
  timestamp: string
  kind: TimelineKind
  location: ITimelineLocation | null
  unavailableReason: TimelineUnavailableReason | null
}

export const apiGetUserDailyTimeline = async (userId: number, date?: string) => {
  let url = `/protectee/${userId}/daily-position/timeline`
  if (date) {
    url += `?date=${date}`
  }

  return await apiGet<IUserTimelineItem[]>(url)
}

const useQueryGetUserDailyTimeline = (userId: number, date?: string) => {
  return useQuery({
    enabled: userId > 0,
    queryKey: QueryCacheKeys.user.getUserDailyTimeline(userId, date),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 30000,
    queryFn: async () => {
      const response = await apiGetUserDailyTimeline(userId, date)
      return Array.isArray(response.data) ? response.data : []
    }
  })
}

export default useQueryGetUserDailyTimeline
